module.exports = {
	"writeKey": "DUMMY WRITE KEY"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/segmentIO-example.credentials.json
// module id = 1413
// module chunks = 0